
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinraigad() {



const cardData = {
  keyword: 'Corporate Cab Services in Raigad MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Raigad MIDC',
  headingDescription: `eTravo offers comprehensive and reliable corporate cab services tailored for businesses in Raigad MIDC. Whether it's daily employee transportation, executive travel, or client pickups, our fleet of GPS-enabled, well-maintained vehicles ensures punctuality and comfort. We cater to diverse corporate needs with flexible booking options, including monthly rentals, shift-based scheduling, and on-demand services. Our professional chauffeurs are trained to provide courteous, safe, and efficient rides, helping companies streamline their transport logistics within Raigad MIDC and neighboring areas. Additionally, we prioritize safety and hygiene, maintaining sanitized and air-conditioned vehicles for a pleasant travel experience. Partner with eTravo for hassle-free corporate commuting solutions that support your business operations smoothly.`,
  
  top: 'Key Industrial Landmarks in Raigad MIDC Served by eTravo',
  topPlaces: [
    {
      title: 'Raigad Industrial Park',
      description: 'A major industrial zone housing manufacturing units and corporate offices. eTravo provides scheduled cab services for employees and management commuting to this hub, ensuring timely and reliable transport.'
    },
    {
      title: 'MIDC Tarapur',
      description: 'An important industrial area with numerous factories and offices. Our corporate cab services cater to daily staff transport and client travel requirements at MIDC Tarapur.'
    },
    {
      title: 'Raigad Logistics Hub',
      description: 'Serving logistics and warehousing companies, our cab services support smooth and punctual travel for staff and executives involved in supply chain operations.'
    },
    {
      title: 'Raigad Business Park',
      description: 'A commercial center with various corporate offices. We facilitate efficient corporate transport for employees, visitors, and business meetings here.'
    }
  ],
  
  services: [
    {
      name: 'Raigad MIDC Corporate Cab Rentals',
      description: 'Customizable cab rental plans suitable for all business sizes in Raigad MIDC, including short-term and long-term options to meet employee transportation demands.'
    },
    {
      name: 'Employee Transport Cab Raigad MIDC',
      description: 'Daily and shift-based employee commute services with real-time tracking and on-time pickups to ensure smooth attendance and punctuality.'
    },
    {
      name: 'Business Cab Services Raigad MIDC',
      description: 'Professional cab solutions for business owners, executives, and visiting clients, featuring a range of vehicles from sedans to executive SUVs.'
    },
    {
      name: 'Corporate Staff Cabs Raigad MIDC',
      description: 'Structured transport services designed to manage staff pickup/drop routes efficiently with multi-stop scheduling and GPS monitoring.'
    },
    {
      name: 'Reliable Corporate Cab Service Raigad MIDC',
      description: 'Committed to punctuality, cleanliness, and professional driving standards, ensuring a seamless daily commute and business travel experience.'
    },
    {
      name: 'AC Corporate Cabs Raigad MIDC',
      description: 'All vehicles are air-conditioned and sanitized regularly, providing a comfortable environment for employees and clients.'
    },
    {
      name: 'Staff Pickup and Drop Cab Raigad MIDC',
      description: 'Flexible pickup and drop services aligned with company shift timings, maximizing operational efficiency and employee convenience.'
    },
    {
      name: 'Affordable Business Cab Rentals Raigad MIDC',
      description: 'Cost-effective cab rental solutions with flexible billing, , and contract options to suit various corporate budgets.'
    },
    {
      name: 'Executive Cab Services Raigad MIDC',
      description: 'Premium transportation for company executives and VIP guests with professional chauffeurs and luxury vehicle options.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Raigad MIDC',
      description: 'Comprehensive monthly plans to support consistent and reliable employee transport needs across the industrial zone.'
    },
    {
      name: 'Industrial Area Employee Transport Raigad MIDC',
      description: 'End-to-end transportation coordination for daily commutes, shift changes, and multi-stop routing within Raigad MIDC.'
    },
    {
      name: 'Corporate Client Cabs Raigad MIDC',
      description: 'Dedicated cab services for client visits, meetings, and corporate events, ensuring comfort and timely arrivals.'
    },
    {
      name: 'Business Meeting Cabs Raigad MIDC',
      description: 'On-demand cab services to facilitate business meetings and quick intra-city travel across Raigad MIDC.'
    },
    {
      name: 'Raigad Industrial Area Cab Hire',
      description: 'Reliable cab hire options for business travel, events, and inter-office commutes within Raigad MIDC.'
    },
    {
      name: 'Corporate Shuttle Cabs Raigad MIDC',
      description: 'Shuttle services for large corporate teams with scheduled pickups and drop-offs designed for convenience and efficiency.'
    }
  ],

  tableData: [
    ['Raigad MIDC Corporate Cab Rentals', 'Employee Transport Cab Raigad MIDC'],
    ['Business Cab Services Raigad MIDC', 'Corporate Staff Cabs Raigad MIDC'],
    ['Reliable Corporate Cab Service Raigad MIDC', 'AC Corporate Cabs Raigad MIDC'],
    ['Staff Pickup and Drop Cab Raigad MIDC', 'Affordable Business Cab Rentals Raigad MIDC'],
    ['Executive Cab Services Raigad MIDC', 'Monthly Corporate Cab Rentals Raigad MIDC'],
    ['Industrial Area Employee Transport Raigad MIDC', 'Corporate Client Cabs Raigad MIDC'],
    ['Business Meeting Cabs Raigad MIDC', 'Raigad Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Raigad MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services for Raigad MIDC with Industrial Precision",
    "WhyChoosedescription": "eTravo offers specialized cab services tailored for the diverse industrial zones of Raigad MIDC, including Taloja, Patalganga, Roha, and Mahad. With Raigad being a hub for chemical, pharmaceutical, and manufacturing units, our services are designed to support industries with dependable employee and executive transport. Our end-to-end solutions enhance workforce punctuality, reduce absenteeism, and provide peace of mind with safe and comfortable rides—critical for companies operating in remote or heavily industrial areas."
  },
  {
    "WhyChooseheading": "A Diverse Fleet for Every Business Travel Requirement",
    "WhyChoosedescription": "Our fleet includes a wide variety of vehicles—from executive sedans and hatchbacks to large-capacity MUVs—ensuring businesses can select the right vehicle for every use case, whether it’s employee shuttles, VIP pick-ups, or plant-to-plant travel. All vehicles are maintained to the highest safety and comfort standards."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Industrial Zones of Raigad",
    "WhyChoosedescription": "Our drivers are highly trained and have extensive knowledge of Raigad MIDC’s key industrial belts, including routes with high cargo traffic and remote facilities. Their experience ensures that employees arrive safely and on time, even in unpredictable traffic or weather conditions."
  },
  {
    "WhyChooseheading": "Flexible Booking for Shifts and Business Operations",
    "WhyChoosedescription": "We offer scalable booking options including fixed schedules for shift workers, multi-route planning, and on-demand travel. This flexibility makes it easy for companies to adjust transportation logistics as per changing work hours, project demands, or growing team sizes."
  },
  {
    "WhyChooseheading": "Live Ride Monitoring and Centralized GPS Tracking",
    "WhyChoosedescription": "Our cabs are GPS-enabled, allowing real-time tracking for all corporate rides. Admins and HR teams can monitor trip progress, ensure driver accountability, and get instant alerts in case of route deviations—boosting safety and operational oversight."
  },
  {
    "WhyChooseheading": "Transparent, Itemized Billing and Invoicing",
    "WhyChoosedescription": "We provide clear, monthly GST-compliant invoices with trip-level details, distance traveled, fare breakdowns, and time logs. This makes it easier for corporate finance departments to track costs, prepare reports, and process reimbursements without discrepancies."
  },
  {
    "WhyChooseheading": "Strict Hygiene and Safety Measures",
    "WhyChoosedescription": "All vehicles undergo regular sanitization and health compliance checks. Our drivers are trained in hygiene protocols, wear masks, and maintain clean environments throughout the journey—ensuring employee safety, especially in long-distance travel."
  },
  {
    "WhyChooseheading": "Dedicated Account Managers for Tailored Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to ensure personalized service, proactive support, and quick resolution of queries. We help streamline the entire transportation process—from planning routes to handling escalations—so you can focus on your core operations."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas of Raigad MIDC do you serve?",
      answer: "We cover all major industrial belts in Raigad including Taloja, Patalganga, Mahad, Roha, and surrounding MIDC zones, providing comprehensive employee and executive transportation."
    },
    {
      question: "Do you support shift-based and recurring ride scheduling?",
      answer: "Yes, we provide scheduling for fixed and rotating shifts, ideal for manufacturing units and multi-shift operations in industrial parks."
    },
    {
      question: "Can we receive monthly invoices with trip logs?",
      answer: "Absolutely. We provide monthly digital invoices with detailed trip logs, fare summaries, and GST-compliant documentation for easy reconciliation."
    },
    {
      question: "Are your drivers trained in safety and corporate conduct?",
      answer: "Yes, our drivers are trained in defensive driving, industrial route handling, and maintaining professional etiquette with passengers."
    },
    {
      question: "How do you ensure the safety of rides in remote areas?",
      answer: "Our GPS-based tracking system, real-time ride monitoring, and 24/7 customer support ensure that employee safety is prioritized, even in remote and less-populated routes."
    },
    {
      question: "Is a dedicated support executive provided for ongoing coordination?",
      answer: "Yes, every business account receives a dedicated account manager for daily coordination, schedule adjustments, and issue resolution."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Nilesh Patil",
    designation: "Plant Admin, Galaxy Chemicals Pvt Ltd",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s service in Taloja MIDC has brought immense reliability to our employee transportation. Timely pickups and well-maintained cabs have improved our shift operations.”"
  },
  {
    name: "Ms. Deepali Thakur",
    designation: "HR Manager, EcoSteel Industries",
    rating: [1, 1, 1, 1, 1],
    text: "“Professional drivers, detailed billing, and flexible scheduling—eTravo is the transport partner we trust for our operations in Mahad MIDC.”"
  }
];





























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Raigad MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-raigad-midc.jpg",
  "description": "Reliable corporate cab service in Raigad MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-raigad-midc"
  }
};







    return (
        <div>
<Helmet>
  <title>Cab Service in Raigad MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Raigad MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinraigad;